<template>
  <v-layout wrap>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-flex>
      <v-img
        class="white--text align-center"
        style=" height:100vh"
        src="../../assets/images/Asset 1.png"
      >
        <v-layout wrap justify-center text-center>
          <v-flex md4 align-self-center>
            <v-form>
              <v-layout wrap align-self-center text-center>
                <v-flex xs12 class="head"> Welcome Too </v-flex>
                <v-flex xs12 class="font"> School Management System </v-flex>
                <v-flex xs12>
                  <v-img
                    height="200px"
                    contain
                    src="../../assets/images/Asset 2.png"
                  >
                  </v-img>
                </v-flex>
                <v-flex xs12 class="font1"> We have sent you an OTP </v-flex>
                <v-flex xs12 class="sub"
                  >Enter the 4 digit OTP sent on {{ pageData.phoneno }}
                </v-flex>
                <v-flex xs12 class="sub"> to continue </v-flex>
                <v-flex
                  py-8
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  align-self-center
                  text-center
                >
                  <v-form ref="form" lazy-validation v-model="formValid">
                    <v-layout wrap justify-center text-center>
                      <v-flex text-center 0ffset-2 xs6 sm3 md5 lg4 xl3 px-xl-6>
                        <v-otp-input
                          input-classes="otp-input"
                          :numInputs="4"
                          separator
                          :shouldAutoFocus="true"
                          @on-complete="validateOTP"
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex xs12 pt-4 text-center>
                        <span
                          v-if="otpexpired"
                          style="font-size: 15px; color: red; cursor: pointer"
                          @click="sentOTP"
                          >Request again</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout
                      justify-center
                      v-if="msg2 && !otpexpired"
                      py-4
                      wrap
                    >
                      <v-flex xs12 text-center>
                        <span
                          style="
                            font-size: 14px;
                            font-family: nunitosansregular;
                            color: red;
                          "
                          >{{ msg2 }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>

                <v-flex py-12 xs12>
                  <v-btn
                    elevation="0"
                    style="background-color: #9eaade; color: white"
                    class="sub"
                    width="280px"
                    @click="validateInput()"
                  >
                    CONTINUE
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-img>
    </v-flex>
  </v-layout>
</template>
<script>
// import VieOtpInput from "@bachdgvn/vue-otp-input";
import axios from "axios";
import store from "../../store";
export default {
  props: ["pageData"],
  data() {
    return {
      phoneno: this.pageData.phoneno,
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      msg2: null,
      otp: "",
      timeLeft: "00:00",
      intervalTimer: null,
      otpexpired: false,
      loading: false,
      formValid: false,
      role:["Admin","SuperAdmin"]
    };
  },
  //   computed: {
  //     prefix() {
  //       return ''
  //     }
  //   },
  beforeMount() {
    this.setTime(60);
  },
  methods: {
    validateOTP(value) {
      this.otp = value;

      this.validateInput();
    },
    validateInput() {
      this.login();
    },
    login() {
      // this.$router.push("/")
      this.appLoading = true;
      var userData = {};
      userData["phone"] = this.pageData.phoneno;
      userData["otp"] = this.otp;
      userData["role"] = this.role;
      axios({
        method: "POST",
        url: "/user/login",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("loginUser", true);
            store.commit("userData", response.data.userdata);
            console.log(response.data.data);
            localStorage.setItem("token", response.data.data.token);
            if (response.data.data.currentRole=='Admin') {
              //   store.commit("userType", true);
              this.$router.push("/login3");
            }   else if(response.data.data.currentRole == "SuperAdmin"){
                              this.$router.push("/login3");
            }else {
              this.msg2 = "Unauthorised access";
            }
          } else {
            this.msg2 = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    sentOTP() {
      var userData = {};
      userData["phone"] = this.pageData.phoneno;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.setTime(60);
            this.otpexpired = false;
            this.msg = "OTP Sent Successfully";
            this.showsnackbar = true;
          } else {
            this.msg = "Something Went Wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 0) this.otpexpired = true;
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
    },
  },
};
</script>
<style lang="sass" scoped>
.__card
  max-width: 600px
  margin: 0 auto

.layout-auth

  height: 50%
  width: 100%
  position: absolute
  top: 0
  left: 0
  content: ""
  z-index: 0

.layout-authi

  height: 100%
  width: 100%
</style>
<style >
.layout-auth-background {
  background-color: #171515;
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.layout-authi {
  height: 100%;
  width: 100%;
}

.otp-input {
  width: 35px !important;
  height: 35px !important;
  color: white;
  margin-left: 5px;
  font-size: 20px !important;
  border-bottom: 1px solid #d6d6d6;
  outline: 0;
  border-width: 1px 1px 1px;
  text-align: center;
  padding-left: 0;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #c8c8c8;
}
.separator::before {
  margin-right: 0.25em;
}
.separator::after {
  margin-left: 0.25em;
}
@media screen and (max-width: 768px) {
  .otp-input {
    width: 25px !important;
    height: 25px !important;
    padding: 4px !important;
    margin: 0 10px;
    font-size: 15px !important;
    border: 1px solid #d6d6d6;
    outline: 0;
    border-width: 1px 1px 1px;
    text-align: "center";
    padding-left: 12px;
  }
}
</style>